// Golf 6a (oprichter 26 sep; docs/DESIGN.md §8.QR, §8.W9b): uitleg "Zo koppel je een iPad aan het
// bord", koppelen met een QR-code, een duidelijker wachtwoordvenster, stappen voor het beginscherm
// met herkenbare plaatjes, "Voor wie?" bij klusjes en "Lees het advies" in de werklijst.
// Toon: je-vorm, korte zinnen, werkwoorden op knoppen, geen jargon (DESIGN §2.9).
//
// Knoppen en menu's van Apple en Google heten in de stappen zoals op een toestel in DEZE taal
// ("Zet op beginscherm", "Voeg toe", "App installeren"), zodat je ze herkent.
export const appGolf6Nl = {
    // ---- Zo koppel je een iPad aan het bord (Instellingen · Tablets en /pair) --------------------
    tabletGuide: {
        title: 'Zo koppel je een iPad aan het bord',
        intro: 'Drie stappen, ongeveer een minuut. Houd deze pagina erbij.',
        step1Title: 'Open Safari op de iPad',
        step1Body: 'Typ dit adres in de adresbalk:',
        copy: 'Kopieer',
        copied: 'Gekopieerd',
        /** Schermlezer: "Kopieer het adres board.amumin.app". */
        copyLabel: 'Kopieer het adres {url}',
        step2Title: 'Het bord laat een code zien',
        step2Body: 'Acht tekens, zoals ABCD-2345. Laat de iPad zo staan.',
        step3Title: 'Vul de code hier in',
        step3Body: 'Kies ook de kamer waar het bord hangt. Het bord verschijnt binnen een paar seconden.',
        enterCode: 'Code invullen',
        orTitle: 'Liever niets typen?',
        orBody: 'Maak een QR-code en scan hem met de camera van de iPad. Het bord koppelt zichzelf.',
        qrButton: 'Koppel met QR-code',
        tipsTitle: 'Tips voor een bord aan de muur',
        tips: [
            {
                title: 'Zet het bord op het beginscherm',
                body: 'Dan opent het bord schermvullend, zonder adresbalk. Doe dit vóór het koppelen: een app op het beginscherm heeft een eigen geheugen en wordt apart gekoppeld.',
            },
            {
                title: 'Automatisch slot: Nooit',
                body: 'Instellingen › Beeldscherm en helderheid › Automatisch slot › Nooit. Laat de iPad aan de lader, dan blijft het scherm aan.',
            },
            {
                title: 'Begeleide toegang',
                body: 'Instellingen › Toegankelijkheid › Begeleide toegang (oudere iPad met iOS 12: Instellingen › Algemeen › Toegankelijkheid › Begeleide toegang): zet het aan en kies een code. Open het bord en druk drie keer snel op de thuisknop (of de bovenste knop). Zo blijven kinderen in het bord.',
            },
            {
                title: 'Tik één keer voor geluid',
                body: 'Een iPad speelt pas geluid na een tik. Tik na het opstarten één keer op het bord, dan hoor je de azaan en de oproepen.',
            },
        ],
        homeScreenHow: 'Hoe zet ik het op het beginscherm?',
    },
    // ---- Koppelen met een QR-code (0040) ----------------------------------------------------------
    qr: {
        title: 'Koppel met QR-code',
        intro: 'De iPad scant de code met de camera en koppelt zichzelf. Je hoeft niets te typen.',
        room: 'Kamer',
        name: 'Naam van de tablet',
        /** Voorstel voor de naam; {room} = "Woonkamer". */
        defaultName: 'iPad {room}',
        create: 'Maak QR-code',
        scanTitle: 'Scan met de camera van de iPad',
        scanSteps: [
            'Open de Camera-app op de iPad.',
            'Richt op deze code tot er bovenin een melding verschijnt.',
            'Tik op de melding. Het bord opent in Safari en koppelt zichzelf.',
        ],
        /** {time} = "9:41". */
        validFor: 'Nog {time} geldig · werkt één keer',
        /** Schermlezer: naam van de QR-code. */
        qrLabel: 'QR-code om een tablet te koppelen in {room}',
        waiting: 'Wachten tot de iPad scant…',
        claimed: '{name} is gekoppeld',
        claimedBody: 'Het bord in {room} laat nu de agenda zien.',
        expired: 'Deze QR-code is verlopen',
        expiredBody: 'Een QR-code werkt 10 minuten en één keer. Maak een nieuwe.',
        again: 'Nieuwe QR-code',
        done: 'Klaar',
        safariNote: 'De QR-code opent het bord in Safari. Staat het bord al op het beginscherm? Koppel die app dan met de code.',
        keepPrivate: 'Laat deze code niet aan anderen zien: wie hem scant, krijgt het bord van jullie gezin.',
    },
    // ---- QR naar de ouderapp voor je telefoon (op een computer) -----------------------------------
    phoneQr: {
        title: 'Open AMUMIN op je telefoon',
        body: 'Scan deze code met de camera van je telefoon. Zet AMUMIN daarna op je beginscherm.',
        label: 'QR-code naar {url}',
    },
    // ---- Zet … op je beginscherm (stappen met plaatjes) -------------------------------------------
    install: {
        platform: 'Welk toestel?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Computer',
        /** Achter het toestel dat we herkennen: "iPhone/iPad (dit toestel)". */
        thisDevice: '{platform} (dit toestel)',
        /** {url} = "amumin.app" of "board.amumin.app"; {app} = "AMUMIN" of "het bord". */
        iosSteps: [
            'Open {url} in Safari.',
            'Tik op Deel: het vierkantje met het pijltje omhoog. Op een iPhone zit het onderin, op een iPad bovenin naast het adres. Zie je het niet? Tik dan eerst op ···.',
            'Veeg of scroll in het deelmenu tot je Zet op beginscherm ziet en tik erop. Op een oudere iPad staat het in de onderste rij: veeg die naar links.',
            'Tik rechtsboven op Voeg toe.',
            'Open {app} voortaan met het icoon op je beginscherm.',
        ],
        androidSteps: [
            'Open {url} in Chrome.',
            'Tik rechtsboven op de drie puntjes.',
            'Kies App installeren (of Toevoegen aan startscherm).',
            'Tik op Installeren. {app} staat nu tussen je apps.',
        ],
        desktopSteps: [
            'Open {url} in Chrome of Edge.',
            'Klik rechts in de adresbalk op het installeer-icoontje (een schermpje met een pijltje).',
            'Klik op Installeren. {app} opent voortaan in een eigen venster.',
        ],
        /** Namen van knoppen zoals het toestel ze in deze taal toont (in de plaatjes). */
        ui: {
            share: 'Deel',
            addToHome: 'Zet op beginscherm',
            add: 'Voeg toe',
            cancel: 'Annuleer',
            installApp: 'App installeren',
            install: 'Installeren',
        },
        /** Schermlezer: uitleg bij de plaatjes. */
        pictureLabel: 'Voorbeeld van stap {n}',
    },
    // ---- Wachtwoordvenster (step-up) -------------------------------------------------------------
    stepUp: {
        /** {host} = "amumin.app". */
        which: 'Vul je eigen AMUMIN-wachtwoord in: hetzelfde waarmee je inlogt op {host}.',
        notThese: 'Dus niet het wifi-wachtwoord en niet de code van de iPad.',
        why: 'We vragen dit bij belangrijke stappen, zoals een tablet koppelen. Daarna hoeft het 10 minuten niet meer.',
        account: 'Je account',
        password: 'Je AMUMIN-wachtwoord',
        forgot: 'Wachtwoord vergeten?',
    },
    // ---- Klusjes: voor wie? ----------------------------------------------------------------------
    tasks: {
        forWho: 'Voor wie?',
        forWhoHint: 'De kinderen staan al aan. Tik op een naam om iemand toe te voegen of weg te halen.',
        nobody: 'Kies minstens één persoon.',
    },
    // ---- Werklijst: het advies bij een punt -------------------------------------------------------
    werklijstDoc: {
        read: 'Lees het advies',
        /** Schermlezer, bij de knop: "Lees het advies: Productnaam en shop.amumin.com". */
        readLabel: 'Lees het advies: {title}',
        loading: 'Het advies wordt geladen…',
        missing: 'Dit advies staat nog niet in deze versie van de app.',
        error: 'Het advies is nu niet te lezen. Probeer het straks opnieuw.',
        back: 'Terug',
        external: '(opent in een nieuw venster)',
    },
};
//# sourceMappingURL=golf6App.nl.js.map